import { render, staticRenderFns } from "./categ_image.vue?vue&type=template&id=4f921794&scoped=true&"
import script from "./categ_image.vue?vue&type=script&lang=js&"
export * from "./categ_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f921794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f921794')) {
      api.createRecord('4f921794', component.options)
    } else {
      api.reload('4f921794', component.options)
    }
    module.hot.accept("./categ_image.vue?vue&type=template&id=4f921794&scoped=true&", function () {
      api.rerender('4f921794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_image.vue"
export default component.exports